import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { GenericConfig } from '@signature-it/ngx-generic/config';
declare let _: any;

@Component({
    selector: 'orders-layout-full',
    templateUrl: './full.html',
    styleUrls: ['./full.scss'],
    standalone: false
})
export class OrdersFullLayoutComponentGeneric {
    @Input('items') items = {
        TransactionItems: Array<object>(),
        allItems: Array<object>(),
        OrderItems: Array<object>()
    };
    @Input('isProductsAmountWithinRange') isProductsAmountWithinRange = true;
    @Output() clearAll = new EventEmitter();
    @Output() updateAll = new EventEmitter();
    @Output() clearItem = new EventEmitter();
    actionsConf = {
        showEdit: false,
        showClearAll: true,
        showUpdateAll: true
    };
    basket: any = {};
    inventoryCheck: boolean = GenericConfig.inventoryCheck ? true: false;
    hideProductImageBox: boolean = GenericConfig.hideProductImageBox || false;
    cartProductLimitCount: number = GenericConfig.cartProductLimitCount || 0;

    constructor(protected router: Router) {}

    onRemoveAll() {
        this.clearAll.next(true);
    }

    onUpdateAll() {
        const basket = [];
        Object.keys(this.basket).forEach(productId => {
            if (isNaN(this.basket[productId])) {
                this.onRemoveItem(this.basket[productId]);
            } else {
                basket.push({
                    product_id: productId,
                    quantity: this.basket[productId]
                });
            }
        });
        this.basket = {};
        this.updateAll.next(basket);
    }

    onUpdateCart(data){
        const basket = [];
        if (isNaN(this.basket[data])) {
            this.onRemoveItem(this.basket[data]);
        } else {
            basket.push({
                product_id: data,
                quantity: this.basket[data]
            });
        }
        this.basket = {};
        this.updateAll.next(basket);
    }

    onRemoveItem(item: object) {
        this.clearItem.next(item);
    }

    goToProductPage(item: object) {
        this.router.navigate(['/product-page', item['ProductID']]);
    }

    onQtyChanged(data) {
        const found = _.find(this.items.TransactionItems, (item: any) => item.ProductID === data.id);
        if (found) {
            if (data.qty === 0) this.basket[data.id] = found;
            else this.basket[data.id] = data.qty - found['ItemQuantity'];
        }
    }

    getPriceAfterDiscount(price, quantityDiscount, quantityDiscountType, qty) {
        if (quantityDiscountType === 'percent') {
            return price * (100 - +(quantityDiscount)) / 100;
        } else { // quantity_discount_type === 'fixed'
            return price - +(quantityDiscount) * qty;
        }
    }
}
